import React, { useEffect, useRef } from 'react'
import { useLoadboardTheme } from './loadboardTheme'
import { Label, DeferredNumberInput, makeInputBase } from './FilterFields'
import SourceDropdown from './SourceDropdown'
import LastSeenDropdown from './LastSeenDropdown'

function FiltersModal({ isOpen, onClose, filters, onChange }) {
	const { theme, tokens } = useLoadboardTheme()
	const isLight = theme === 'light'
	const inputBase = makeInputBase(tokens)
	const popoverRef = useRef(null)

	useEffect(() => {
		if (!isOpen) return
		const onKeyDown = e => {
			if (e.key === 'Escape') onClose?.()
		}
		const onMouseDown = e => {
			if (!popoverRef.current) return
			if (popoverRef.current.contains(e.target)) return
			const trigger = e.target.closest('[data-filters-trigger]')
			if (trigger) return
			onClose?.()
		}
		document.addEventListener('keydown', onKeyDown)
		document.addEventListener('mousedown', onMouseDown)
		return () => {
			document.removeEventListener('keydown', onKeyDown)
			document.removeEventListener('mousedown', onMouseDown)
		}
	}, [isOpen, onClose])

	if (!isOpen) return null

	const set = patch => onChange({ ...filters, ...patch })

	const resetAdvanced = () => {
		onChange({
			...filters,
			source: 'all',
			lastSeenHours: '',
			maxWeight: '',
			minDistance: '',
			maxDistance: '',
			showArchive: false,
		})
	}

	return (
		<div
			ref={popoverRef}
			role="dialog"
			aria-label="Filters"
			className={`absolute left-0 top-full mt-1 z-40 w-[380px] rounded-lg shadow-xl ${tokens.pageBg} ${tokens.pageText} ring-1 ${
				isLight ? 'ring-gray-200' : 'ring-white/10'
			}`}
		>
			<div className="px-4 py-4 flex flex-col gap-4">
				<div className="grid grid-cols-[2fr_1fr] gap-x-3">
					<SourceDropdown
						value={filters.source || 'all'}
						onChange={v => set({ source: v })}
					/>
					<LastSeenDropdown
						value={filters.lastSeenHours}
						onChange={v => set({ lastSeenHours: v })}
					/>
				</div>

				<div className="grid grid-cols-3 gap-x-3">
					<div>
						<div className={tokens.slimFieldShell}>
							<Label>Max Weight</Label>
							<DeferredNumberInput
								min="0"
								step="500"
								value={filters.maxWeight}
								onCommit={v => set({ maxWeight: v })}
								placeholder="Any lbs"
								className={inputBase}
							/>
						</div>
					</div>

					<div>
						<div className={tokens.slimFieldShell}>
							<Label>Min Distance</Label>
							<DeferredNumberInput
								min="0"
								step="50"
								value={filters.minDistance}
								onCommit={v => set({ minDistance: v })}
								placeholder="Any mi"
								className={inputBase}
							/>
						</div>
					</div>

					<div>
						<div className={tokens.slimFieldShell}>
							<Label>Max Distance</Label>
							<DeferredNumberInput
								min="0"
								step="50"
								value={filters.maxDistance}
								onCommit={v => set({ maxDistance: v })}
								placeholder="Any mi"
								className={inputBase}
							/>
						</div>
					</div>
				</div>
			</div>

			<div
				className={`flex items-center justify-end px-4 py-2 border-t ${
					isLight ? 'border-gray-200' : 'border-white/10'
				}`}
			>
				<button
					type="button"
					onClick={resetAdvanced}
					className={`text-xs font-medium ${
						isLight ? 'text-gray-600 hover:text-gray-900' : 'text-gray-400 hover:text-gray-200'
					}`}
				>
					Reset
				</button>
			</div>
		</div>
	)
}

export default FiltersModal
